import React from 'react';
import { Link } from "gatsby";
import Layout from "../../layouts/tc";
import eventCover from '../../images/event-dream.jpg';

export default function Home(props) {
  return (
    <Layout location={props.location} title="從全職工作到成為啟發學生追夢的企業家">
      <div className="lg:py-20 py-10">
        <div className="container mx-auto px-4 lg:px-0">
          <nav class="mb-4">
            <Link to="/tc">首頁</Link>
            <span class="mx-3 text-gray-700">/</span>
            <span class="text-gray-500">從全職工作到成為啟發學生追夢的企業家</span>
          </nav>

          <div className="mt-5">
            <div className="lg:flex">
              <div className="lg:w-96">
                <img src={eventCover} className="rounded" alt="" />
              </div>
              <div className="lg:flex-1 lg:ml-10">
                <h1 className="lg:text-2xl font-bold lg:mt-0 mt-5">從全職工作到成為啟發學生追夢的企業家</h1>
                
                <div className="mt-5 leading-loose">
                  <p>嘉賓講者將分享他的企業經歷，為何他由前美資銀行副總裁及著名填詞人，毅然轉行走入夢想之路，開辦社企，並鼓勵學生追夢，積極為社會帶來影響。同學將嘉賓分享中得到啟發。</p>
                  <div className="mt-5 border-t pt-5">
                    <div className="lg:flex lg:items-center">
                      <label className="lg:w-48 text-gray-500">日期/時間:</label>
                      <div className="lg:flex-1">
                      5月3日下午4時至5時
                      </div>
                    </div>
                    <div className="lg:flex lg:items-center mt-3">
                      <label className="lg:w-48 text-gray-500">講者:</label>
                      <div className="lg:flex-1">
                      籽識教育創辦人王仲傑先生
                      </div>
                    </div>
                    <div className="lg:flex lg:items-center mt-3">
                      <label className="lg:w-48 text-gray-500">地點:</label>
                      <div className="lg:flex-1">
                      以Zoom線上形式進行
                      </div>
                    </div>
                    <div className="lg:flex mt-3">
                      <label className="lg:w-48 text-gray-500">名額:</label>
                      <div className="lg:flex-1">
                        90
                        <p className="text-blue-600">(由於同學反應熱烈﹐名額由50增至90)</p>
                      </div>
                    </div>
                    <div className="lg:flex lg:items-center mt-3">
                      <label className="lg:w-48 text-gray-500">報名截止日期:</label>
                      <div className="lg:flex-1">
                      4月28日
                      </div>
                    </div>
                    <p className="mt-5">
                    活動名額有限，先到先得。活動Zoom 連結將於活動舉行一日前，以電郵通知成功報名活動的同學。
                    </p>
                    <a href="https://eduhk.au1.qualtrics.com/jfe/form/SV_0wiudOzAT7dhYBo" className="cta mt-5 inline-block" target="_blank" rel="noreferrer">報名</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
};